export default {
  home: 'Home',
  youthRregist: 'Youth competition registration',
  carnivalRregist: 'Registration for the ancient town carnival',
  mediaRegist: 'Media Registration',
  listTheatreFestival: 'List of activities at the Wuzhen Theatre Festival',
  contactUs: 'Contact Us',
  supportUs: 'Support Us',
  followUs: 'Follow Us',
  friendshipLink: 'Friendship link',
  introduce: 'Introduce',
  constitution: 'Constitution',
  growth:
    'You can reach out to us through the following methods to assist our robust growth:',
  specialthanks: 'Special thanks list',
  performntroduction: 'About the Show',
  mediaCommentary: 'Reviews',
  editorIntroduction: "Editor's Introduction",
  directorIntroduction: 'About the Director',
  actorJobSchedule: 'Credits',
  troupeIntroduction: 'About the Theatre Company',
  director: 'Director',
  time: 'Time',
  site: 'Site',
  duration: 'Duration',
  generalPlanner: 'General planner',
  brilliant: 'Brilliant International',
  classicRefact: 'Classic Refactoring',
  masterMaster: "Master's masterpiece",
  fullSearch: 'full text search',
  search: 'search',
  searchHistory: 'Search history',
  searchInfor: 'Please enter the search information',
  total: 'total',
  items: 'items',
  searchItems: 'search for information',
  mediaRegist: 'Media Registration',
  moreDates: 'More dates',
  noData: 'No data',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',

  back: 'Back',
  viewDetails: 'View details',
  prevArticle: 'Previous article',
  nextArticle: 'Next article',
  prevPage: 'Previous page',
  nextPage: 'Next page',
  isFirst: 'This is already the first article',
  isLast: 'This is the last article',
  isFirstPage: 'It is already the first page',
  isFirstLast: 'This is the last page',
};
